module.exports = __webpack_public_path__ + "img/1.072575ce.jpg";